import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { 
    Box, IconButton, Modal, Container, Typography, Button, Divider, Checkbox, 
    FormControlLabel, Grid, Chip, Paper, useTheme, useMediaQuery, CircularProgress 
} from "@mui/material";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import CloseIcon from "@mui/icons-material/Close";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import moment from "moment";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import { image } from "../../common/Theme";
import { Header } from "../../component/Header";
import Apiconnection from "../../utils/Apiconnection";
import { showError } from "../Validation";
import PaymentForm from "./PaymentForm";
import PolicyModal from "../../component/PolicyModal";

const stripepromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLIC_KEY ||
    "pk_test_51Q5GGKCvBhAhbwykB7YUNoeg8dkZBQPXmPi6YMqQt0N5YHe3xrARSxIC8u3fCyhabQU5ZSVhkFy6YnSnQy2bMhpK00a94t2sfm"
);

const getDurationLabel = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return "Choose your times";
  }

  const duration = moment.duration(moment(endDate).diff(moment(startDate)));
  const totalMinutes = Math.max(duration.asMinutes(), 0);
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = Math.floor(totalMinutes % 60);
  const segments = [];

  if (days) {
    segments.push(`${days}d`);
  }
  if (hours) {
    segments.push(`${hours}h`);
  }
  if (minutes || segments.length === 0) {
    segments.push(`${minutes}m`);
  }

  return segments.join(" ");
};

const formatDateTime = (value) => {
  if (!value) {
    return "--";
  }

  return moment(value).format("ddd, DD MMM • h:mm A");
};

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") {
    return "--";
  }

  return `$${value}`;
};

const CustomDateInput = React.forwardRef(({ value, onClick, placeholder, disabled, isOpen, isError }, ref) => (
  <Box
    onClick={!disabled ? onClick : undefined}
    sx={{
      border: isError ? '2px solid #ef4444' : '1px solid #e2e8f0',
      borderRadius: '12px',
      px: 2,
      py: 1.5,
      display: 'flex',
      alignItems: 'center',
      backgroundColor: disabled ? '#f8fafc' : '#fff',
      opacity: disabled ? 0.7 : 1,
      cursor: disabled ? 'not-allowed' : 'pointer',
      transition: 'all 0.2s',
      '&:hover': { borderColor: disabled ? '#e2e8f0' : '#004777' },
      width: '100%',
      boxSizing: 'border-box'
    }}
  >
    <CalendarTodayOutlinedIcon sx={{ color: '#64748b', fontSize: '18px', mr: 1.5, flexShrink: 0 }} />
    <input
      ref={ref}
      value={value || ''}
      readOnly
      placeholder={placeholder}
      disabled={disabled}
      style={{
        border: 'none',
        outline: 'none',
        width: '100%',
        fontSize: '15px',
        color: '#1e293b',
        fontWeight: 600,
        backgroundColor: 'transparent',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontFamily: "'Inter', sans-serif"
      }}
    />
    <KeyboardArrowDownIcon
      sx={{
        color: '#94a3b8',
        transform: isOpen ? 'rotate(180deg)' : 'none',
        transition: '0.3s',
        flexShrink: 0
      }}
    />
  </Box>
));

const BookingCreate = () => {
  const location = useLocation();
  const state = location.state || {};
  const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
  const payload = state.payload || {};

  const customerId = state.customerId || userInfo?.id || payload?.customerId;
  const firstName =
    state.firstName || userInfo?.firstName || payload?.firstname || payload?.firstName;
  const lastName =
    state.lastName || userInfo?.lastName || payload?.lastname || payload?.lastName;
  const email = state.email || userInfo?.email || payload?.email;
  const rawPhone = state.phone || userInfo?.phone || payload?.password || payload?.phone;
  const phone = rawPhone != null && String(rawPhone).trim() !== "" ? String(rawPhone).trim() : "";

  const [termsAgreed, setTermsAgreed] = useState(false);
  const [errors, setErrors] = useState({});
  const [isStartOpen, setIsStartOpen] = useState(false);
  const [isEndOpen, setIsEndOpen] = useState(false);

  const [policyModalOpen, setPolicyModalOpen] = useState(false);
  const [policyModalTab, setPolicyModalTab] = useState('terms');
  
  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [licensePlateNumber, setLicensePlateNumber] = useState("");
  const [slotId, setSlotId] = useState("");
  const [slotName, setSlotName] = useState("");

  const [fname] = useState(payload?.firstname || payload?.firstName || firstName);
  const [lname] = useState(payload?.lastname || payload?.lastName || lastName);

  const [clientsecret, setclientsecret] = useState(null);
  const [stripeorderid, setstripeorderid] = useState(null);
  const [totalDueAmount, settotalDueAmount] = useState(null);
  const [onlineBookingAmount, setonlineBookingAmount] = useState(null);
  const [totalPaidAmount, settotalPaidAmount] = useState(null);
  const [parkingChargeTotal, setparkingChargeTotal] = useState(null);
  const [reservationAmount, setreservationAmount] = useState(null);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paymentFormPayload, setPaymentFormPayload] = useState(payload);

  useEffect(() => {
    if (startDate && moment(startDate).isBefore(moment())) {
      setstartDate(new Date());
    }
  }, [startDate]);

  useEffect(() => {
    if (endDate && moment(endDate).isBefore(moment())) {
      setendDate(new Date());
    }
  }, [endDate]);

  const openPolicy = (tab) => {
    setPolicyModalTab(tab);
    setPolicyModalOpen(true);
  };

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setTermsAgreed(isChecked);
    if (errors.terms) {
      setErrors((prev) => ({ ...prev, terms: null }));
    }
  };

  const handleSlotCheck = async () => {
    if (!startDate || !endDate) {
      return;
    }

    const slotPayload = {
      checkinDate: moment(startDate).format("YYYY-MM-DD"),
      startTime: moment(startDate).format("HH:mm:ss"),
      checkoutDate: moment(endDate).format("YYYY-MM-DD"),
      endTime: moment(endDate).format("HH:mm:ss"),
    };

    setLoading(true);
    try {
      const response = await Apiconnection.post("decide-slot", slotPayload);
      if (response?.data?.status) {
        setSlotId(response.data.data.bookedSlot.id);
        setSlotName(response.data.data.bookedSlot.slotName);
        toast.success("Slot available");

        // Dynamically fetch charges
        const chargeSummaryPayload = {
          parkingGroundId: "1",
          platform: "CustomerPanel",
          vendorId: "",
          onSiteChargeForVendor: "",
          vehicleTypeId: "72",
          passengerCount: "4",
          checkinDate: moment(startDate).format("YYYY-MM-DD"),
          startTime: moment(startDate).format("HH:mm:ss"),
          checkoutDate: moment(endDate).format("YYYY-MM-DD"),
          endTime: moment(endDate).format("HH:mm:ss"),
          reservationId: "",
        };

        const chargeSummaryResponse = await Apiconnection.post(
          "pre-booking-charge-summary",
          chargeSummaryPayload
        );
        const bookingChargesSummary =
          chargeSummaryResponse?.data?.data?.bookingChargesSummary || {};

        settotalDueAmount(bookingChargesSummary.dueAmount);
        settotalPaidAmount(bookingChargesSummary.paidAmount);
        setonlineBookingAmount(bookingChargesSummary.onlineBookingAmount);
        setparkingChargeTotal(bookingChargesSummary.parkingChargeTotal);
        setreservationAmount(bookingChargesSummary.reservationAmount);

      } else {
        setSlotId("");
        setSlotName("");
        toast.error("Slot not available");
      }
    } catch (error) {
      console.error("Error checking slot availability:", error);
      toast.error("Error checking availability. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenPaymentModal = async () => {
    const newErrors = {};

    if (!startDate) {
      newErrors.startDate = "Start date is required.";
    }

    if (!endDate) {
      newErrors.endDate = "End date is required.";
    }

    if (!licensePlateNumber) {
      newErrors.licensePlateNumber = "Plate number is required.";
    }

    if (!termsAgreed) {
      newErrors.terms = "Please accept the Terms & Conditions and No-Refund Policy.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.error("Please correct the highlighted fields before continuing.");
      return;
    }

    setLoading(true);

    let activeSlotId = slotId;
    let activeSlotName = slotName;

    // Guard: Automatically check and confirm slot allocation if missing
    if (!activeSlotId && startDate && endDate) {
      try {
        const slotPayload = {
          checkinDate: moment(startDate).format("YYYY-MM-DD"),
          startTime: moment(startDate).format("HH:mm:ss"),
          checkoutDate: moment(endDate).format("YYYY-MM-DD"),
          endTime: moment(endDate).format("HH:mm:ss"),
        };
        const slotResponse = await Apiconnection.post("decide-slot", slotPayload);
        if (slotResponse?.data?.status && slotResponse?.data?.data?.bookedSlot?.id) {
          activeSlotId = slotResponse.data.data.bookedSlot.id;
          activeSlotName = slotResponse.data.data.bookedSlot.slotName;
          setSlotId(activeSlotId);
          setSlotName(activeSlotName);
        }
      } catch (err) {
        console.error("Error confirming slot allocation:", err);
      }
    }

    if (!activeSlotId) {
      toast.error("No parking slot is currently available for these dates/times. Please choose different timings.");
      setLoading(false);
      return;
    }

    const customerFirstName = String((customerId ? firstName : fname) || payload?.firstName || payload?.firstname || "").trim();
    const customerLastName = String((customerId ? lastName : lname) || payload?.lastName || payload?.lastname || "").trim();
    const fullName = `${customerFirstName} ${customerLastName}`.trim();
    const customerIdentifier = customerId ? String(customerId) : fullName;
    const customerEmail = String((customerId ? email : payload?.email) || "").trim();
    const rawCustomerPhone = (customerId ? phone : (payload?.phone || payload?.password));
    const customerPhone = rawCustomerPhone != null && String(rawCustomerPhone).trim() !== "" ? String(rawCustomerPhone).trim() : "";

    if (!customerEmail || !customerPhone) {
      toast.error("Customer email and mobile number are required. Please verify your details before continuing.");
      setLoading(false);
      return;
    }

    try {
      const chargeSummaryPayload = {
        parkingGroundId: "1",
        platform: "CustomerPanel",
        vendorId: "",
        onSiteChargeForVendor: "",
        vehicleTypeId: "72",
        passengerCount: "4",
        checkinDate: moment(startDate).format("YYYY-MM-DD"),
        startTime: moment(startDate).format("HH:mm:ss"),
        checkoutDate: moment(endDate).format("YYYY-MM-DD"),
        endTime: moment(endDate).format("HH:mm:ss"),
        reservationId: "",
      };

      const chargeSummaryResponse = await Apiconnection.post(
        "pre-booking-charge-summary",
        chargeSummaryPayload
      );
      const bookingChargesSummary =
        chargeSummaryResponse?.data?.data?.bookingChargesSummary || {};

      settotalDueAmount(bookingChargesSummary.dueAmount);
      settotalPaidAmount(bookingChargesSummary.paidAmount);
      setonlineBookingAmount(bookingChargesSummary.onlineBookingAmount);
      setparkingChargeTotal(bookingChargesSummary.parkingChargeTotal);
      setreservationAmount(bookingChargesSummary.reservationAmount);

      let totalAmount = bookingChargesSummary.reservationAmount;
      if (bookingChargesSummary.payableAmount < bookingChargesSummary.reservationAmount) {
        totalAmount = bookingChargesSummary.payableAmount;
      }
      if (!totalAmount || Number(totalAmount) <= 0) {
        totalAmount = 25;
      }

      const consentTime = new Date().toISOString();
      const paymentPayload = {
        amount: String(totalAmount),
        currency: "USD",
        firstName: customerFirstName,
        lastName: customerLastName,
        name: fullName,
        customer: customerIdentifier,
        customerName: fullName,
        userId: userInfo?.id,
        email: customerEmail,
        phone: customerPhone,
        legal_consent_timestamp: consentTime,
        isConsentAccepted: true,
        terms_version_accepted: "v2026.1",
        cancellation_policy: "strict_no_refund",
      };

      const response = await Apiconnection.post(
        "create-payment-intent-with-stripe",
        paymentPayload
      );

      const secret =
        response?.data?.data?.client_secret ||
        response?.data?.data?.clientSecret ||
        response?.data?.data?.paymentIntent;

      if (!secret) {
        toast.error("Payment configuration error: missing client secret.");
        return;
      }

      const extractedSecret = typeof secret === "string" ? secret : secret.client_secret;
      if (!extractedSecret || !extractedSecret.includes("_secret_")) {
        toast.error("Invalid client secret received from server.");
        return;
      }

      console.log("Stripe clientSecret received from backend:", extractedSecret);
      setclientsecret({ clientSecret: extractedSecret });
      setstripeorderid(response?.data?.data?.stripeOrderId);

      setPaymentFormPayload({
        ...payload,
        customerId: customerId || payload?.customerId,
        licensePlateNumber,
        slotId: activeSlotId,
        slotName: activeSlotName,
        fromDate: moment(startDate).format("YYYY-MM-DD"),
        selectedCheckInTime: moment(startDate).format("HH:mm:ss"),
        toDate: moment(endDate).format("YYYY-MM-DD"),
        selectedCheckOutTime: moment(endDate).format("HH:mm:ss"),
        email: customerEmail,
        phone: customerPhone,
        dialCode: customerId ? location.state?.dialcode || "+1" : payload?.dialcode || "+1",
        firstName: customerFirstName,
        lastName: customerLastName,
        firstname: customerFirstName,
        lastname: customerLastName,
        name: fullName,
        customer: customerIdentifier,
        customerName: fullName,
      });

      // Open modal only when payment intent and confirmed slot are ready
      setOpenPaymentModal(true);
    } catch (error) {
      console.error("Error creating payment intent:", error);
      toast.error("Failed to create payment intent.");
    } finally {
      setLoading(false);
    }
  };

  const handleClosePaymentModal = () => {
    setOpenPaymentModal(false);
  };

  const summaryRows = [
    { label: "Check-in", value: formatDateTime(startDate) },
    { label: "Check-out", value: formatDateTime(endDate) },
    { label: "Duration", value: getDurationLabel(startDate, endDate) },
    { label: "Vehicle", value: licensePlateNumber || "Add your plate number" },
    { label: "Allocated slot", value: slotName || "Auto-assigned after timing check" },
  ];

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div
      className="booking-main booking-create-page"
      style={{ backgroundColor: '#f5f7fa', minHeight: '100vh', position: 'relative' }}
    >
      <div style={{ 
        position: 'absolute', 
        top: 0, left: 0, right: 0, 
        height: '350px', 
        backgroundColor: '#001b44', 
        backgroundImage: `url(${image.bodybg})`, 
        backgroundSize: 'cover', 
        backgroundPosition: 'center', 
        zIndex: 0 
      }}></div>
      
      <div className="booking-inner booking-create-inner" style={{ position: 'relative', zIndex: 1 }}>
        <Header />
        
        <Container maxWidth="xl" sx={{ mt: 2, pb: 8 }}>
          <Paper 
            elevation={0}
            sx={{ 
              backgroundColor: '#fff', 
              borderRadius: '24px', 
              p: { xs: 3, md: 5 }, 
              boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
              fontFamily: "'Inter', 'Poppins', sans-serif"
            }}
          >
            {/* Header Section */}
            <Box sx={{ mb: 5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                <Box sx={{ width: '60px', height: '60px', backgroundColor: '#f0f7ff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <CalendarTodayOutlinedIcon style={{ color: '#004777', fontSize: '28px' }} />
                </Box>
                <Box>
                  <Typography variant="h3" sx={{ fontWeight: 800, color: '#1a1a1a', letterSpacing: '-1px', mb: 0.5, fontSize: { xs: '28px', sm: '32px' } }}>
                    Book Your Parking
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#64748b', fontWeight: 500 }}>
                    Choose your timing, add your vehicle, and confirm with confidence. Secure your premium parking spot in just a few steps.
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Grid container spacing={5}>
              {/* Left Column: Form Fields */}
              <Grid item xs={12} lg={8}>
                <Box>
                  <style>
                    {`
                      .react-datepicker-wrapper { width: 100%; display: block; }
                      .react-datepicker__input-container { width: 100%; display: block; }
                      .react-datepicker-popper { z-index: 9999 !important; }
                      .react-datepicker {
                        border: 1px solid #e2e8f0 !important; border-radius: 16px !important;
                        overflow: hidden; box-shadow: 0 10px 25px rgba(0,0,0,0.1) !important;
                        font-family: 'Inter', sans-serif !important;
                      }
                      .react-datepicker__header { background: #f8fafc !important; border-bottom: 1px solid #e2e8f0 !important; }
                      .react-datepicker__day--selected,
                      .react-datepicker__day--keyboard-selected { background: #004777 !important; border-radius: 8px !important; color: #fff !important; }
                      .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
                        background-color: #004777 !important;
                      }
                      .react-datepicker__input-container input::placeholder {
                        color: #64748b !important;
                        opacity: 1 !important;
                        font-weight: 500 !important;
                      }
                    `}
                  </style>

                  {/* Trip Details */}
                  <Typography variant="h5" sx={{ fontWeight: 700, color: '#1a1a1a', mb: 3 }}>Trip Details</Typography>
                  <Grid container spacing={3} sx={{ mb: 4 }}>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748b', mb: 1, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Check-in</Typography>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => {
                          setstartDate(date);
                          if (errors.startDate) setErrors((prev) => ({ ...prev, startDate: null }));
                        }}
                        onCalendarOpen={() => setIsStartOpen(true)}
                        onCalendarClose={() => { setIsStartOpen(false); handleSlotCheck(); }}
                        minDate={new Date()}
                        placeholderText="Select check-in"
                        showTimeSelect
                        dateFormat="dd MMM, yyyy h:mm aa"
                        customInput={
                          <CustomDateInput
                            placeholder="Select check-in"
                            isOpen={isStartOpen}
                            isError={!!errors.startDate}
                          />
                        }
                      />
                      {showError(errors.startDate)}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748b', mb: 1, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Check-out</Typography>
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => {
                          setendDate(date);
                          if (errors.endDate) setErrors((prev) => ({ ...prev, endDate: null }));
                        }}
                        onCalendarOpen={() => setIsEndOpen(true)}
                        onCalendarClose={() => { setIsEndOpen(false); handleSlotCheck(); }}
                        minDate={startDate || new Date()}
                        placeholderText="Select check-out"
                        disabled={!startDate}
                        showTimeSelect
                        dateFormat="dd MMM, yyyy h:mm aa"
                        customInput={
                          <CustomDateInput
                            placeholder="Select check-out"
                            disabled={!startDate}
                            isOpen={isEndOpen}
                            isError={!!errors.endDate}
                          />
                        }
                      />
                      {showError(errors.endDate)}
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 4 }} />

                  {/* Vehicle Details */}
                  <Typography variant="h5" sx={{ fontWeight: 700, color: '#1a1a1a', mb: 3 }}>Vehicle Details</Typography>
                  <Box sx={{ mb: 4 }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748b', mb: 1, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Plate Number</Typography>
                    <Box sx={{ 
                      border: errors.licensePlateNumber ? '2px solid #ef4444' : '1px solid #e2e8f0', 
                      borderRadius: '12px', px: 2, py: 1.5, display: 'flex', alignItems: 'center', 
                      backgroundColor: '#fff', transition: 'all 0.2s',
                      '&:hover': { borderColor: '#004777' }
                    }}>
                      <DirectionsCarOutlinedIcon sx={{ color: '#64748b', fontSize: '20px', mr: 1.5 }} />
                      <input
                        type="text"
                        maxLength={10}
                        placeholder="e.g. ABC-123"
                        value={licensePlateNumber}
                        style={{ border: 'none', outline: 'none', width: '100%', fontSize: '15px', color: '#1e293b', fontWeight: 600, fontFamily: 'inherit' }}
                        onChange={(event) => {
                          setLicensePlateNumber(event.target.value.toUpperCase());
                          if (errors.licensePlateNumber) setErrors((prev) => ({ ...prev, licensePlateNumber: null }));
                        }}
                      />
                    </Box>
                    {showError(errors.licensePlateNumber)}
                  </Box>

                  <Box sx={{ mt: 5, p: 3, backgroundColor: '#f0f7ff', borderRadius: '16px', border: '1px solid #e0eefc', display: 'flex', gap: 2 }}>
                    <Box sx={{ pt: 0.5 }}>
                      <Box sx={{ width: '24px', height: '24px', backgroundColor: '#004777', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '12px', fontWeight: 'bold' }}>i</Box>
                    </Box>
                    <Box>
                      <Typography sx={{ fontWeight: 700, color: '#004777', fontSize: '14px', mb: 0.5 }}>Slot Allocation</Typography>
                      <Typography sx={{ color: '#475569', fontSize: '14px' }}>
                        Based on your timing, we will automatically allocate the best available slot: <strong>{slotName || "TBA"}</strong>
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              {/* Right Column: Summary & Payment */}
              <Grid item xs={12} lg={4}>
                <Box sx={{ position: { lg: 'sticky' }, top: '20px' }}>
                  <Paper 
                    elevation={0}
                    sx={{ 
                      backgroundColor: '#f8fafc', 
                      borderRadius: '20px', 
                      p: 3, 
                      border: '1px solid #e2e8f0',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                  >
                    {loading && (
                      <Box sx={{ 
                        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, 
                        backgroundColor: 'rgba(255,255,255,0.7)', zIndex: 10,
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        backdropFilter: 'blur(2px)'
                      }}>
                        <CircularProgress size={40} sx={{ color: '#004777', mb: 2 }} />
                        <Typography sx={{ fontWeight: 700, color: '#004777', fontSize: '14px' }}>Calculating Charges...</Typography>
                      </Box>
                    )}
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#1a1a1a', mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <AccessTimeOutlinedIcon style={{ color: '#004777' }} /> Booking Summary
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, mb: 4 }}>
                      {summaryRows.map((row) => (
                        <Box key={row.label} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                          <Typography sx={{ color: '#64748b', fontSize: '13px', fontWeight: 600 }}>{row.label}</Typography>
                          <Typography sx={{ color: '#1e293b', fontSize: '14px', fontWeight: 700, textAlign: 'right', maxWidth: '65%' }}>{row.value}</Typography>
                        </Box>
                      ))}
                    </Box>

                    <Divider sx={{ mb: 3 }} />

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 4 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography sx={{ color: '#64748b', fontSize: '13px', fontWeight: 600 }}>Online Booking Charges</Typography>
                        <Typography sx={{ color: '#1e293b', fontSize: '15px', fontWeight: 700 }}>{formatCurrency(onlineBookingAmount)}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography sx={{ color: '#64748b', fontSize: '13px', fontWeight: 600 }}>Parking Charges</Typography>
                        <Typography sx={{ color: '#1e293b', fontSize: '15px', fontWeight: 700 }}>{formatCurrency(parkingChargeTotal)}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography sx={{ color: '#64748b', fontSize: '13px', fontWeight: 600 }}>Reservation Charges</Typography>
                          <Chip 
                            label="Non-refundable" 
                            size="small" 
                            sx={{ backgroundColor: '#fee2e2', color: '#b91c1c', fontSize: '10px', fontWeight: 800, height: '18px' }} 
                          />
                        </Box>
                        <Typography sx={{ color: '#1e293b', fontSize: '15px', fontWeight: 700 }}>{formatCurrency(reservationAmount)}</Typography>
                      </Box>
                    </Box>

                    {/* Non-Refund Alert Box */}
                    <Box
                      sx={{
                        backgroundColor: '#fffbeb',
                        border: '1px solid #fde68a',
                        borderRadius: '12px',
                        p: 1.5,
                        mb: 3,
                        display: 'flex',
                        gap: 1.2,
                        alignItems: 'flex-start'
                      }}
                    >
                      <InfoOutlinedIcon sx={{ color: '#d97706', fontSize: '20px', mt: 0.1, flexShrink: 0 }} />
                      <Typography sx={{ fontSize: '12px', color: '#78350f', lineHeight: 1.4 }}>
                        <strong>No-Refund Policy:</strong> Reservation fees are strictly non-refundable upon booking.
                      </Typography>
                    </Box>

                    <Box sx={{ backgroundColor: '#fff', borderRadius: '12px', p: 2, mb: 3, border: '1px dashed #004777' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Typography sx={{ fontWeight: 700, color: '#1a1a1a' }}>Payable Today</Typography>
                        <Typography sx={{ fontSize: '24px', fontWeight: 800, color: '#004777' }}>{formatCurrency(totalPaidAmount)}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '13px', color: '#64748b', fontWeight: 600 }}>Amount to pay On-Site</Typography>
                        <Typography sx={{ fontSize: '15px', fontWeight: 700, color: '#1e293b' }}>{formatCurrency(totalDueAmount)}</Typography>
                      </Box>
                    </Box>

                    <Box sx={{ mb: 3 }}>
                      <FormControlLabel
                        control={
                          <Checkbox 
                            size="small" 
                            checked={termsAgreed} 
                            onChange={handleCheckboxChange}
                            sx={{ color: '#004777', '&.Mui-checked': { color: '#004777' } }}
                          />
                        }
                        label={
                          <Typography sx={{ fontSize: '12px', color: '#475569', fontWeight: 500, lineHeight: 1.4 }}>
                            I have read and agree to the{' '}
                            <span 
                              role="button"
                              tabIndex={0}
                              onClick={(e) => {
                                e.stopPropagation();
                                openPolicy('terms');
                              }}
                              style={{ color: '#004777', textDecoration: 'underline', fontWeight: 700, cursor: 'pointer' }}
                            >
                              Terms of Service
                            </span>{' '}
                            and explicitly authorize this transaction. I understand and accept the{' '}
                            <span 
                              role="button"
                              tabIndex={0}
                              onClick={(e) => {
                                e.stopPropagation();
                                openPolicy('refund');
                              }}
                              style={{ color: '#004777', textDecoration: 'underline', fontWeight: 700, cursor: 'pointer' }}
                            >
                              Strict No-Refund Policy
                            </span>
                            , and agree that all fees paid for Prime Park are final and non-refundable.
                          </Typography>
                        }
                      />
                      {showError(errors.terms)}
                    </Box>

                    <Button 
                      fullWidth 
                      variant="contained"
                      onClick={handleOpenPaymentModal}
                      disabled={loading}
                      sx={{ 
                        backgroundColor: '#004777', 
                        py: 2, 
                        borderRadius: '100px', 
                        fontWeight: 700, 
                        fontSize: '16px',
                        textTransform: 'none',
                        boxShadow: '0 8px 20px rgba(0, 71, 119, 0.2)',
                        '&:hover': { backgroundColor: '#003355' }
                      }}
                    >
                      {loading ? "Checking..." : "Continue to Payment"}
                    </Button>
                  </Paper>

                  <Box sx={{ mt: 3, p: 2, display: 'flex', alignItems: 'center', gap: 2, opacity: 0.8 }}>
                    <ShieldOutlinedIcon sx={{ color: '#22c55e' }} />
                    <Typography sx={{ fontSize: '12px', color: '#64748b', fontWeight: 500 }}>
                      Secure payment processing by Stripe. Your details are never stored.
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>

            {/* Trust Banners Footer */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 8, pt: 4, borderTop: '1px solid #e2e8f0', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 3, md: 0 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box sx={{ width: '40px', height: '40px', backgroundColor: '#f0f7ff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><LockOutlinedIcon style={{ color: '#0b57d0' }} /></Box>
                    <Box><Typography sx={{ fontWeight: 700, fontSize: '13px' }}>Secure & Reliable</Typography><Typography sx={{ color: '#64748b', fontSize: '12px' }}>Your data is always protected</Typography></Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box sx={{ width: '40px', height: '40px', backgroundColor: '#ebfdf4', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><ShieldOutlinedIcon style={{ color: '#22c55e' }} /></Box>
                    <Box><Typography sx={{ fontWeight: 700, fontSize: '13px' }}>Hassle-Free Parking</Typography><Typography sx={{ color: '#64748b', fontSize: '12px' }}>Book, park & go with ease</Typography></Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box sx={{ width: '40px', height: '40px', backgroundColor: '#f3e8ff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><HeadsetMicOutlinedIcon style={{ color: '#9333ea' }} /></Box>
                    <Box><Typography sx={{ fontWeight: 700, fontSize: '13px' }}>24/7 Support</Typography><Typography sx={{ color: '#64748b', fontSize: '12px' }}>We're here to help anytime</Typography></Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box sx={{ width: '40px', height: '40px', backgroundColor: '#fff7ed', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><StarBorderOutlinedIcon style={{ color: '#f97316' }} /></Box>
                    <Box><Typography sx={{ fontWeight: 700, fontSize: '13px' }}>Trusted by Thousands</Typography><Typography sx={{ color: '#64748b', fontSize: '12px' }}>Thank you for choosing Prime Park</Typography></Box>
                </Box>
            </Box>
          </Paper>
        </Container>
      </div>

      {/* Policy Modal (Terms & Refund Policy) */}
      <PolicyModal
        open={policyModalOpen}
        onClose={() => setPolicyModalOpen(false)}
        initialTab={policyModalTab}
        onAccept={() => setTermsAgreed(true)}
      />

      {/* Checkout / Payment Modal */}
      <Modal open={openPaymentModal} onClose={handleClosePaymentModal}>
        <Box sx={{ 
          position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', 
          backgroundColor: '#fff', borderRadius: '24px', overflow: 'hidden', 
          display: 'flex', flexDirection: { xs: 'column', md: 'row' }, 
          width: '95%', maxWidth: '960px', height: { xs: '90vh', md: '640px' }, maxHeight: '92vh',
          boxShadow: '0 30px 80px rgba(0,0,0,0.25)', outline: 'none'
        }}>
          {/* Summary Panel */}
          <Box sx={{ 
            width: { xs: '100%', md: '38%' }, 
            backgroundColor: '#f8fafc', 
            p: { xs: 3, md: 4 }, 
            borderRight: '1px solid #e2e8f0',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto'
          }}>
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 3, color: '#0f172a' }}>
              Booking Summary
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.8, flex: 1 }}>
              {[
                { label: 'Customer', value: customerId ? `${firstName || ""} ${lastName || ""}` : `${fname || ""} ${lname || ""}` },
                { label: 'Vehicle', value: licensePlateNumber },
                { label: 'Check-in', value: formatDateTime(startDate) },
                { label: 'Check-out', value: formatDateTime(endDate) },
                { label: 'Online Booking Charges', value: formatCurrency(onlineBookingAmount) },
                { label: 'Parking Charges', value: formatCurrency(parkingChargeTotal) },
                { 
                  label: 'Reservation Charges', 
                  value: formatCurrency(reservationAmount),
                  badge: 'Non-refundable'
                },
                { label: 'Amount to pay now', value: formatCurrency(totalPaidAmount), highlight: true },
                { label: 'Amount to pay On-Site', value: formatCurrency(totalDueAmount) }
              ].map((item) => (
                <Box key={item.label} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                    <Typography sx={{ color: '#64748b', fontSize: '13px', fontWeight: 600 }}>{item.label}</Typography>
                    {item.badge && (
                      <Chip label={item.badge} size="small" sx={{ backgroundColor: '#fee2e2', color: '#b91c1c', fontSize: '9px', fontWeight: 800, height: '16px' }} />
                    )}
                  </Box>
                  <Typography sx={{ fontWeight: item.highlight ? 800 : 700, fontSize: item.highlight ? '16px' : '13.5px', color: item.highlight ? '#004777' : '#1e293b' }}>
                    {item.value}
                  </Typography>
                </Box>
              ))}
            </Box>

            <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <LockOutlinedIcon sx={{ color: '#004777', fontSize: '18px' }} />
              <Typography sx={{ fontSize: '12px', color: '#64748b', fontWeight: 500 }}>
                256-bit SSL Encrypted Checkout
              </Typography>
            </Box>
          </Box>

          {/* Payment Panel */}
          <Box sx={{ 
            width: { xs: '100%', md: '62%' }, 
            p: { xs: 3, md: 4 }, 
            position: 'relative', 
            display: 'flex', 
            flexDirection: 'column', 
            minHeight: 0,
            backgroundColor: '#ffffff'
          }}>
            <IconButton 
              onClick={handleClosePaymentModal} 
              sx={{ 
                position: 'absolute', 
                top: 16, 
                right: 16,
                backgroundColor: '#f8fafc',
                '&:hover': { backgroundColor: '#e2e8f0' }
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>

            <Box sx={{ mb: 2 }}>
              <Typography variant="h5" sx={{ fontWeight: 800, color: '#0f172a', fontSize: { xs: '20px', md: '24px' } }}>
                Secure Checkout
              </Typography>
              <Typography sx={{ color: '#64748b', fontSize: '13.5px', fontWeight: 500 }}>
                Complete your deposit payment securely via Stripe.
              </Typography>
            </Box>

            <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
              {clientsecret?.clientSecret && (
                <Elements stripe={stripepromise} options={clientsecret}>
                  <PaymentForm
                    payload={paymentFormPayload}
                    clientsecret={clientsecret}
                    stripeorderid={stripeorderid}
                    totalAmount={totalPaidAmount}
                    onCancel={handleClosePaymentModal}
                  />
                </Elements>
              )}
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default BookingCreate;
